import React from 'react'
import { Typewriter ,Cursor} from 'react-simple-typewriter'
import resume from '../static/resume.pdf'
import { Helmet } from 'react-helmet'
import ScrollToTop from '../utils/ScrollToTop'
export default function Resume() {
  return (
    <>
    <ScrollToTop />
    <Helmet>
        <title>_resume</title>
    </Helmet>

    <div className='flex items-center justify-center'>
    <div className='section-width'>
    <div>
        <div className='section-heading pt-4'>
            &#123;
            <Typewriter  words={["_Resume"]} typeSpeed={200} />
            <Cursor />
            &#125;
        </div>
        <p className='body-color text-center'>
            a snapshot of my skills, experiences, and achievements.
        </p>
        <div className='flex items-center justify-center pt-4'>
        <a href={resume} className='button-style' download>
            Download
        </a>
        </div>
    </div>
    <div>
        <div className='section-heading pt-[50px]'>
        &lt;
        <Typewriter words={["Skills"]} typeSpeed={200} />
        &gt;
        </div>
        <div className='grid sm:grid-cols-1 md:grid-cols-2 items-start pl-2 pr-2'>
            <div>
                <h4 className='text-white text-xl code-font'>Web Development</h4>
                <div className='flex flex-wrap'>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_bootstrap</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_tailwind</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_javascript</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_react</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_next.js</p>
                </div>
            </div>
            <div>
                <h4 className='text-white text-xl code-font'>iOS Development</h4>
                <div className='flex flex-wrap'>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_swift</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_swift_ui</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_core_data</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_ui_kit</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_user_notification</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_core_location</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_map_kit</p>

                </div>

            </div>
            <div>
                <h4 className='text-white text-xl code-font'>ML / DL</h4>
                <div className='flex flex-wrap'>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_python</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_numpy/_pandas</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_tensorflow/_pytorch</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_sklearn</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_open_cv</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_numba/_cython</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_py_qt_5</p>

                </div>
            </div>
            
            <div>
                <h4 className='text-white text-xl code-font'>Other</h4>
                <div className='flex flex-wrap'>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_figma</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_microsoft_office_suite</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_graphics_designing</p>
                    <p className='text-gray-800 code-font bg-slate-200 rounded-lg p-2 m-2 hover:bg-slate-800 hover:text-gray-200'>_final_cut_pro</p>
                </div>
            </div>
        </div>
        
    </div>
    <div>
        <div className='section-heading pt-[50px]'>
        &lt;
        <Typewriter words={["Experience"]} typeSpeed={200} />
        &gt;
        </div>
        <div className='grid items-center justify-center pl-2 pr-2'>
        <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>2022 - Current</p>
                    <div className='text-primary-color code-font text-xl '>
                        &#123;
                        <Typewriter words={["Youtube Content Creator"]} typeSpeed={200} />
                        &#125;
                    </div>
                    <p className='md:col-span-2 body-color'>
                    • Have around million of views on my channel with over 2k+ subscribers. <br />
                    • Create videos for topics like Web Development, Data Science, Machine Learning, and many more.
                    </p>
                    <div className='flex flex-row-reverse md:col-span-4'>
                    <a className='button-style' href="https://youtube.com/c/recoding">View Here</a>
                    </div>
                </div>
        <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>2018 - 2020</p>
                    <div className='text-primary-color code-font text-xl '>
                        &#123;
                        <Typewriter words={["Full Stack Developer @ TekSolSys"]} typeSpeed={200} />
                        &#125;
                    </div>
                    <p className='md:col-span-2 body-color'>
                    • Developed websites and web application for clients. <br />
                    • Developed many projects from various fields which include CMS and E-Commerce.</p>
                </div>
                <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>2016 - 2018</p>
                    <div className='text-primary-color code-font text-xl'>
                        &#123;
                        <Typewriter words={["Technical Writer @ Tech Awareness"]} typeSpeed={200} />
                        &#125;
                    </div>
                    <p className='md:col-span-2 body-color'>
                    • Write articles about new technologies and new releases technological trends. <br />
                    • Perform Article Editing, SEO and Graphics.
                    </p>
                    <div className='flex flex-row-reverse md:col-span-4'>
                    <a className='button-style' href="https://www.techawarness.com">View Here</a>
                    </div>
                </div>
                
                
        </div>
        
    </div>
        {/* Education Section */}

    <div>
        <div className='section-heading pt-[50px]'>
        &lt;
        <Typewriter words={["Education"]} typeSpeed={200} />
        &gt;
        </div>
        <div className='grid items-center justify-center pl-2 pr-2'>
                
                <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>2023 - Current</p>
                    <h5 className='text-primary-color text-xl code-font'>Master's Science in E-Mobility @ Friedrich–Alexander University</h5>
                    <p className='md:col-span-2 body-color'>Currently pursing my Master's at Friedrich–Alexander University Erlangen-Nuremberg. 
                    <br />I am doing my majors in Artificial Intelligence or Autonomous driving, E-Powertrain and Production and Sustainable Mobility and Production Technology. 
                    <br />I have studied many different fields which includes Machine Learning, Deep Learning, Data Structures and Algorithm, Computer Vision, Pattern Recognition, Computational Neuroscience, Mechatronics Components System, Power Electronics for Decentralized system, Electrical Energy Storage System, Global Supply Chain, Robotics, Dynamics and Control and many more.</p>
                </div>
                <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>2017 - 2021</p>
                    <h5 className='text-primary-color text-xl code-font'>Bachelor's Technology in Mechatronics @ Delhi Institute of Tool Engineering </h5>
                    <p className='md:col-span-2 body-color'>Completed my Bachelor's at Delhi Institute of Tool Engineering, Delhi India. <br />
                     I have done my majors in Electronics, Control, Instrumentation, Automation and Mechanical. 
                     <br />I have studied many different fields which includes Signal System, Digital Signal Processing, Power Electronics, Automation and Control, Mechanics, Kinematics and Dynamics of Machine, Programmable and Logical Controller, Embedded System and Programming.</p>
                </div>
        </div>
        
    </div>
    {/* Internship Section */}
    <div>
        <div className='section-heading pt-[50px]'>
        &lt;
        <Typewriter words={["Internship"]} typeSpeed={200} />
        &gt;
        </div>
        <div className='grid items-center justify-center pl-2 pr-2'>
                
                <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>Sept 2020 - Oct 2020</p>
                    <h5 className='text-primary-color text-xl code-font'>Data scientist Intern @ Data Science Internship at The Spark Foundation</h5>
                    <p className='md:col-span-2 body-color'>
• Perform Explanatory Data Analysis on the provided dataset
<br />
• Solve problems on Supervised Machine Learning and Unsupervised Machine Learning graphically.</p>
                </div>
                <div className='grid md:grid-cols-4 border rounded border-gray-400 p-2 mt-2'>
                    <p className='text-gray-400'>Jul 2018 - Aug 2018</p>
                    <h5 className='text-primary-color text-xl code-font'>Embedded System & IOT Trainee @ i3indiya Technologies</h5>
                    <p className='md:col-span-2 body-color'>• Project based Training on PIC Microcontrollers
                    <br />
                    • Learn interfacing different components include Switch, Relay, LED's, LCD Display and many more.
                    <br />
                    • Finally Developed a project based on IOT.
                    </p>
                </div>
        </div>
        
    </div>
    </div>
    </div>
    </>
  )
}
